export const ToolKitTourSteps = [{
  title: 'Toolkits Menu',
  description: 'Click to minimize this menu.',
  target: () => document.querySelector('#toolkit-collapse-button')
}, {
  title: 'Search',
  description: 'Use this search bar to quickly find the best resources for your students.',
  target: () => document.querySelector('#toolkits-menu-search')
}, {
  title: 'Teacher Toolkits',
  description: 'Click to navigate the sections of Teacher Toolkits.',
  target: () => document.querySelector('#toolkits-left-menu')
}];